import { NgModule } from '@angular/core';

import { CircularProgressBarComponent } from './circular-progressbar.component';

@NgModule({
  declarations: [CircularProgressBarComponent],
  exports: [CircularProgressBarComponent],
})
export class CircularProgressBarComponentModule {}
